import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgElderCare(props: ISvgProps) {
	return (
		<svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M34.565 57.85a.644.644 0 0 1-.644-.644V37.282a.644.644 0 1 1 1.289 0v19.924a.647.647 0 0 1-.645.645Z"
				fill={props.secondaryColor}
			/>
			<path
				d="M13.132 2.398c-2.5 0-4.533 2.03-4.533 4.535a4.529 4.529 0 0 0 4.533 4.526 4.526 4.526 0 0 0 4.528-4.526 4.533 4.533 0 0 0-4.528-4.535ZM39.963 18.312l.007.002c.687.422 4.235 1.882 8.208-1.837 1.594-1.629 2.35-4.095 2.35-4.095s-1.694.767-3.02.256c-.896-.347-1.789-1.418-1.96-1.631a4.485 4.485 0 0 0-1.526-1.133c-2.334-1.059-5.09 0-6.154 2.358a4.672 4.672 0 0 0 2.095 6.08Z"
				fill={props.primaryColor}
			/>
			<path
				d="M59.389 34.506c-.143-1.793-.64-2.714-1.332-3.825L51.77 19.846s-.506-.828-1.406-1.226c-.506-.225-1.258-.298-2.243-.007L32.321 23.45l-11.269-9.263c-.937-.787-1.94-1.598-3.578-1.598H6.56c-3.143 0-5.956 2.067-5.956 5.588V33.97a1.95 1.95 0 0 0 3.9 0l.005-14.963h1.662v36.288a2.552 2.552 0 0 0 2.554 2.555 2.555 2.555 0 0 0 2.557-2.555l.003-21.005h1.957v21.005a2.556 2.556 0 0 0 2.559 2.555 2.553 2.553 0 0 0 2.555-2.555V19.008s-.033-.508.286-.642c.475-.2.773.131.773.131l11.039 9.07c.014.012.03.02.044.03.061.048.122.09.188.13.042.026.082.054.124.077.063.033.127.061.192.087.047.019.092.042.139.058.077.026.154.043.234.061.037.007.073.021.11.028.117.02.237.03.356.03.139 0 .277-.018.418-.044l.107-.023c.038-.01.073-.014.11-.026l7.632-2.337-6.982 6.396a2.184 2.184 0 0 0 1.479 3.797 2.18 2.18 0 0 0 1.476-.574l9.595-8.796 2.4 3.745v16.51h8.342v1.04H53.38l.019 7.12c0 .688.384 2.963 2.948 2.963 2.037 0 3.045-1.612 3.045-3.075 0-.002.007-20.262-.005-20.26v.002Z"
				fill={props.primaryColor}
			/>
		</svg>
	);
}

export default SvgElderCare;
